import theme from 'config/theme';

export default {
  wrapper: {
    cursor: 'pointer',
    display: 'flex',
    gap: '12px',
    padding: '12px 16px',
    width: '100%',
    alignItems: 'center',
  },
  paper: {
    width: '164px',
    padding: '0',
    flexDirection: 'column',
    alignItems: 'flex-start',
    zIndex: 9999,
    gap: '4px',
    borderRadius: '12px',
    border: '1px solid rgba(0, 0, 0, 0.10)',
    background: '#FFF',
    boxShadow:
      '0px 100px 80px 0px rgba(0, 0, 0, 0.07), 0px 41.778px 33.422px 0px rgba(0, 0, 0, 0.05), 0px 22.336px 17.869px 0px rgba(0, 0, 0, 0.04), 0px 12.522px 10.017px 0px rgba(0, 0, 0, 0.04), 0px 6.65px 5.32px 0px rgba(0, 0, 0, 0.03), 0px 2.767px 2.214px 0px rgba(0, 0, 0, 0.02)',
  },
  userMenuItem: {
    padding: '8px 12px',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    paddingTop: '10px',
    paddingBottom: '10px',
    color: theme.palette.grays.gray600,
    fontSize: '12px',
    svg: {
      width: '15px',
      height: '15px',
    },
    '&:hover': {
      background: 'none',
    },
  },

  logoutItem: {
    borderTop: `1px solid #D9D9D9`,
    padding: '12px 8px !important',
    fontSize: '12px !important',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: theme.palette.grays.gray600,

    svg: {
      width: '13px',
    },
    '&:hover': {
      color: '#000',
      background: 'none',
      svg: {
        color: '#000',
      },
    },
  },
  name: {
    color: '#000',
    fontSize: '13px',
    fontWeight: 500,
    maxWidth: '150px',
    lineHeight: '14px',
    maxHeight: '26px',
    overflow: 'hidden',
    whiteSpace: 'normal',
    display: 'block',
    wordBreak: 'break-word',
  },
  role: {
    color: theme.palette.grays.gray500,
    fontSize: '12px',
    fontWeight: 500,
  },
  userIcon: {
    width: '44px',
    height: '44px',
    color: '#5A5A5A',
  },
  langLabel: {
    fontSize: '10px',
    fontWeight: '500',
    color: '#000',
    padding: '6px 12px',
    lineHeight: '12px',
  },
  avatar: { position: 'relative', display: 'flex', alignItems: 'center' },
  statusDot: {
    position: 'absolute',
    bottom: '3px',
    right: '1px',
    width: 14,
    height: 14,
    backgroundColor: '#41D37E',
    border: '2px solid white',
    borderRadius: '50%',
  },
  logout: { fontSize: '12px', fontWeight: 500, lineHeight: '16px' },
};
